module.exports = __webpack_public_path__ + "img/AddPosHelp5.2448bf9a.png";